import { useState } from "react";
import { useQuery } from "react-query";
import { useIvideon } from "./useIvideon";

export const useCameraCheckStatus = () => {
  const [dealerId, setDealerId] = useState<string>();
  const { cameraCheckStatus } = useIvideon();

  const getDealerId = (prop: string) => {
    setDealerId(prop);
  };

  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ["ivideonCameraCheckStatus", dealerId],
    queryFn: () => cameraCheckStatus(dealerId!),
    onError: (error) => {
      console.log(error);
    },
    refetchOnWindowFocus: false,
    enabled: !!dealerId,
  });

  return {
    data,
    isLoading,
    isError,
    refetch,
    getDealerId,
  };
};
